__turbopack_context__.v({
  "btnCancel": "ConfirmDialog-module__qAMpBa__btnCancel",
  "btnConfirm": "ConfirmDialog-module__qAMpBa__btnConfirm",
  "btnConfirm_danger": "ConfirmDialog-module__qAMpBa__btnConfirm_danger",
  "btnConfirm_info": "ConfirmDialog-module__qAMpBa__btnConfirm_info",
  "btnConfirm_warning": "ConfirmDialog-module__qAMpBa__btnConfirm_warning",
  "content": "ConfirmDialog-module__qAMpBa__content",
  "dialog": "ConfirmDialog-module__qAMpBa__dialog",
  "footer": "ConfirmDialog-module__qAMpBa__footer",
  "header": "ConfirmDialog-module__qAMpBa__header",
  "icon": "ConfirmDialog-module__qAMpBa__icon",
  "iconWrap": "ConfirmDialog-module__qAMpBa__iconWrap",
  "message": "ConfirmDialog-module__qAMpBa__message",
  "title": "ConfirmDialog-module__qAMpBa__title",
  "variant_danger": "ConfirmDialog-module__qAMpBa__variant_danger",
  "variant_info": "ConfirmDialog-module__qAMpBa__variant_info",
  "variant_warning": "ConfirmDialog-module__qAMpBa__variant_warning",
});
